module.exports = __webpack_public_path__ + "img/jerusalem-01.140d0665.png";